import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function MediaVehiclesChannelPage(): React.ReactElement {
  const currentSecurity = useSecurity('MediaVehicles', 'Channel');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/MediaVehicles/Scripts/Resources/en/res.Channel.en.js",
        "Areas/MediaVehicles/Scripts/Resources/en/Types.en.js",
        "Areas/MediaVehicles/Scripts/Enums.js",
        "Areas/MediaVehicles/Scripts/Channel/Index.js"], "initMediaVehiclesChannel", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
